import { Link, createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LuPlus } from "react-icons/lu";

import { PageName, PageNumberController, WatchtowerTable } from "#components";
import { useListedWatchtowers } from "#services";
import { css } from "#styled-system/css";

export const Route = createFileRoute("/_authenticated/management/watchtowers/")({
  component: Component,
});

function Component() {
  const { t } = useTranslation();
  const [pageNumber, setPageNumber] = useState(0);

  const { fetchNextPage, loaded, loading, pages } = useListedWatchtowers(undefined, {
    pageSize: 100,
  });

  const watchtowers = pages.at(Math.min(pageNumber, pages.length - 1))?.watchtowers;

  return (
    <main className={css({ display: "flex", flexDirection: "column" })}>
      <PageName>{t("%WatchtowerList.0%")}</PageName>

      <p className={css({ fontSize: "24px", fontWeight: 700 })}>{t("%WatchtowerList.0%")}</p>

      <div
        className={css({
          alignItems: "flex-end",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
        })}
      >
        <div />
        <div>
          <Link
            className={css({ alignItems: "center", display: "flex", gap: "8px" })}
            to="/management/watchtowers/registration"
          >
            <LuPlus />
            <p>{t("%AddWatchtower.0%")}</p>
          </Link>
        </div>
      </div>

      <div className={css({ overflowX: "auto" })}>
        <WatchtowerTable className={css({ marginY: "8px" })} loading={loading} rows={watchtowers} />
      </div>

      <div
        className={css({
          alignItems: "flex-start",
          display: "flex",
          justifyContent: "space-between",
        })}
      >
        <PageNumberController
          loading={loading}
          next={pageNumber < pages.length || !loaded}
          onNext={function (value) {
            if (value >= pages.length - 1 && !loaded) {
              fetchNextPage().then(function () {
                setPageNumber(value);
              });
            }
          }}
          onPrevious={function (value) {
            setPageNumber(value);
          }}
          value={pageNumber}
        />
      </div>
    </main>
  );
}
